var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlterwealthLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alterwealth_-_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.088,
    height: 121.673,
    viewBox: "0 0 391.088 121.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2823",
    "data-name": "Group 2823",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    d: "M100.222,62.057l-2.266-7.446H82.74l-2.59,7.446H67.2L85.33,12.2h9.389l18.13,49.857ZM90.51,30.977,85.977,44.251h8.741Z",
    transform: "translate(-67.2 -12.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    d: "M94.255,62.057C85.837,62.057,82.6,56.23,82.6,51.05V12.2H94.255V50.078c0,1.619.647,2.266,2.266,2.266h3.885v9.712Z",
    transform: "translate(-32.743 -12.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M104.516,59.82c-8.417,0-11.655-5.827-11.655-11.007V32.625H89.3V23.884h3.561V13.2h11.655V23.884h5.827v8.741h-5.827v15.54c0,1.619.647,2.266,2.266,2.266h3.561v9.712h-5.827Z",
    transform: "translate(-17.752 -9.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    d: "M108.507,39.234c0,3.237,2.266,5.827,6.8,5.827,3.885,0,5.827-.971,7.77-3.237l6.8,6.8c-3.885,3.885-7.77,5.827-14.569,5.827-8.417,0-17.806-2.914-17.806-19.425,0-12.3,7.122-19.425,16.835-19.425,11.007,0,16.835,8.094,16.835,17.806v5.18H108.507Zm10.684-10.36a5.5,5.5,0,0,0-9.712,0,4.811,4.811,0,0,0-.648,2.914h11.331A10.289,10.289,0,0,0,119.191,28.874Z",
    transform: "translate(0.596 -4.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M130.5,28.1a5.769,5.769,0,0,0-4.209-1.942c-1.619,0-4.533.971-4.533,5.18V54H110.1V16.124h11.331v3.237A13.111,13.111,0,0,1,130.5,15.8a11.258,11.258,0,0,1,8.741,3.561Z",
    transform: "translate(28.788 -4.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M168.857,62.057H158.821l-8.094-24.6-8.094,24.6H132.6L119,12.2h12.95l6.475,26.224L146.519,12.2h8.741l8.094,26.224L169.828,12.2h12.95Z",
    transform: "translate(48.701 -12.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M149.707,39.234c0,3.237,2.266,5.827,6.8,5.827,3.885,0,5.828-.971,7.77-3.237l6.8,6.8c-3.885,3.885-7.77,5.827-14.569,5.827-8.417,0-17.806-2.914-17.806-19.425,0-12.3,7.122-19.425,16.835-19.425,11.007,0,16.835,8.094,16.835,17.806v5.18H149.707Zm10.684-10.36a5.5,5.5,0,0,0-9.712,0,4.811,4.811,0,0,0-.648,2.914h11.331A10.288,10.288,0,0,0,160.391,28.874Z",
    transform: "translate(92.78 -4.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M171.22,54V50.765a10.732,10.732,0,0,1-8.418,3.561,13.4,13.4,0,0,1-9.065-3.237,11.719,11.719,0,0,1-3.237-8.741c0-5.827,3.885-11.007,12.95-11.007h7.77v-.971c0-3.561-1.619-4.856-5.827-4.856a7.256,7.256,0,0,0-6.151,2.59l-7.122-7.122c3.885-3.885,7.446-5.18,13.6-5.18,10.684,0,16.511,4.532,16.511,13.6V54ZM170.9,38.786h-5.828c-2.266,0-3.561,1.295-3.561,2.914s1.295,3.237,3.885,3.237a6.329,6.329,0,0,0,4.532-1.295c.971-.647.971-1.942.971-3.885v-.971Z",
    transform: "translate(119.182 -4.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M174.455,62.057c-8.417,0-11.655-5.827-11.655-11.007V12.2h11.655V50.078c0,1.619.648,2.266,2.266,2.266h3.885v9.712Z",
    transform: "translate(146.703 -12.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M184.716,59.82c-8.417,0-11.655-5.827-11.655-11.007V32.625H169.5V23.884h3.561V13.2h11.655V23.884h5.828v8.741h-5.828v15.54c0,1.619.648,2.266,2.266,2.266h3.561v9.712h-5.828Z",
    transform: "translate(161.694 -9.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M198.72,62.057V39.071c0-4.209-2.914-4.856-4.532-4.856a4.456,4.456,0,0,0-4.532,4.856V62.057H178V12.2h11.655V27.416a12.335,12.335,0,0,1,8.417-3.561c8.094,0,11.979,6.151,11.979,13.6v24.6Z",
    transform: "translate(180.713 -12.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    transform: "translate(183.241 66.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M126.39,34.842v6.151h8.741V43.26H126.39v7.122H123.8V32.9h12.3v2.266H126.39Z",
    transform: "translate(-123.8 -32.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M133.932,49.535a7.8,7.8,0,0,1-3.237-3.237,10.539,10.539,0,0,1-1.295-4.532,7.433,7.433,0,0,1,1.295-4.532,10.289,10.289,0,0,1,3.237-3.237,10.725,10.725,0,0,1,4.856-1.295,9.136,9.136,0,0,1,4.856,1.295,7.8,7.8,0,0,1,3.238,3.237,10.539,10.539,0,0,1,1.295,4.532,7.434,7.434,0,0,1-1.295,4.532,10.289,10.289,0,0,1-3.238,3.237,10.724,10.724,0,0,1-4.856,1.3A7.8,7.8,0,0,1,133.932,49.535Zm8.094-1.942a5.1,5.1,0,0,0,2.266-2.266,6.526,6.526,0,0,0,.971-3.561,7.379,7.379,0,0,0-.971-3.561,5.1,5.1,0,0,0-2.266-2.266,7.015,7.015,0,0,0-7.123,0,8.727,8.727,0,0,0-2.59,2.266,6.527,6.527,0,0,0-.971,3.561,7.38,7.38,0,0,0,.971,3.561,4.492,4.492,0,0,0,2.59,2.266,6.526,6.526,0,0,0,3.561.971A5.816,5.816,0,0,0,142.026,47.592Z",
    transform: "translate(-111.27 -32.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M139.443,48.664q-1.942-1.943-1.943-5.827V32.8h2.59v9.712c0,3.885,1.619,5.5,4.856,5.5,1.619,0,2.914-.324,3.561-1.295.971-.971,1.3-2.266,1.3-4.209V32.8h2.266V42.836q0,3.885-1.942,5.827a7.616,7.616,0,0,1-5.5,1.942A6.835,6.835,0,0,1,139.443,48.664Z",
    transform: "translate(-93.146 -32.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M159.692,32.9V50.382H157.75l-10.36-12.95v12.95H144.8V32.9h1.943L157.1,45.85V32.9Z",
    transform: "translate(-76.813 -32.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M152.3,32.9h7.446a10.811,10.811,0,0,1,4.856.971,7.087,7.087,0,0,1,3.238,2.914,10.539,10.539,0,0,1,1.295,4.532,7.434,7.434,0,0,1-1.295,4.532,7.087,7.087,0,0,1-3.238,2.914,10.811,10.811,0,0,1-4.856.971H152.3Zm7.122,15.216a6.526,6.526,0,0,0,3.561-.971,8.728,8.728,0,0,0,2.59-2.266,7.014,7.014,0,0,0,0-7.122,6,6,0,0,0-2.59-2.266,6.526,6.526,0,0,0-3.561-.971h-4.856v12.95h4.856Z",
    transform: "translate(-60.032 -32.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M172.6,46.074h-9.389l-1.942,4.209H159L166.77,32.8h2.59l7.77,17.482h-2.59Zm-.971-1.942-3.885-8.417-3.885,8.417Z",
    transform: "translate(-45.041 -32.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M171.427,35.066H165.6V32.8h14.245v2.266h-5.827V50.282h-2.59Z",
    transform: "translate(-30.273 -32.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M172.1,32.9h2.59V50.382H172.1Z",
    transform: "translate(-15.73 -32.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M179.832,49.535a7.8,7.8,0,0,1-3.237-3.237,10.539,10.539,0,0,1-1.295-4.532,7.433,7.433,0,0,1,1.295-4.532,10.291,10.291,0,0,1,3.237-3.237,10.726,10.726,0,0,1,4.856-1.295,9.136,9.136,0,0,1,4.856,1.295,7.8,7.8,0,0,1,3.238,3.237,10.539,10.539,0,0,1,1.295,4.532,7.434,7.434,0,0,1-1.295,4.532,10.29,10.29,0,0,1-3.238,3.237,10.725,10.725,0,0,1-4.856,1.3A7.8,7.8,0,0,1,179.832,49.535Zm8.094-1.942a5.1,5.1,0,0,0,2.266-2.266,6.526,6.526,0,0,0,.971-3.561,7.379,7.379,0,0,0-.971-3.561,5.1,5.1,0,0,0-2.266-2.266,7.015,7.015,0,0,0-7.123,0,8.727,8.727,0,0,0-2.59,2.266,6.526,6.526,0,0,0-.971,3.561,7.38,7.38,0,0,0,.971,3.561,4.492,4.492,0,0,0,2.59,2.266,7.015,7.015,0,0,0,7.123,0Z",
    transform: "translate(-8.57 -32.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M198.292,32.9V50.382H196.35l-10.36-12.95v12.95H183.4V32.9h1.943L195.7,45.85V32.9Z",
    transform: "translate(9.554 -32.252)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2824",
    "data-name": "Group 2824",
    transform: "translate(0 62.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M62.2,17.2V30.549a7.88,7.88,0,0,1-7.811,7.811,7.788,7.788,0,0,1-7.811-7.811V17.2H30.959V30.549a7.88,7.88,0,0,1-7.811,7.811,7.788,7.788,0,0,1-7.811-7.811V17.2H0V30.549A23.331,23.331,0,0,0,38.912,47.875a23.229,23.229,0,0,0,38.77-17.326V17.2Z",
    transform: "translate(0 5.806)",
    fill: "#faae74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M37.521,8.911h0A7.7,7.7,0,0,0,29.711,1.1,7.788,7.788,0,0,0,21.9,8.911h0v7.669H37.521Z",
    transform: "translate(9.201 -0.958)",
    fill: "#faae74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M59.421,7.107v9.515H43.8V1h9.515A6.061,6.061,0,0,1,59.421,7.107Z",
    transform: "translate(18.402 -1)",
    fill: "#faae74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M15.479,1V16.621H0V7.107A6.032,6.032,0,0,1,5.965,1Z",
    transform: "translate(0 -1)",
    fill: "#faae74"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlterwealthLogo);
export default __webpack_public_path__ + "static/media/alterwealth-logo.cab1c512af97b95257378802e18b7a6b.svg";
export { ForwardRef as ReactComponent };